import React from 'react';
import { RefreshCw, X } from 'lucide-react';
import styles from './SessionUpdateBanner.module.css';

interface SessionUpdateBannerProps {
  isVisible: boolean;
  onRefresh: () => void;
  onDismiss: () => void;
}

export const SessionUpdateBanner: React.FC<SessionUpdateBannerProps> = ({
  isVisible,
  onRefresh,
  onDismiss,
}) => {
  if (!isVisible) return null;

  return (
    <div className={styles.banner}>
      <div className={styles.content}>
        <div className={styles.icon}>
          <RefreshCw size={16} />
        </div>
        <div className={styles.message}>
          <span className={styles.text}>New messages available</span>
          <span className={styles.subtext}>This conversation was updated in another tab</span>
        </div>
        <div className={styles.actions}>
          <button 
            className={styles.refreshButton}
            onClick={onRefresh}
            title="Refresh to see new messages"
          >
            <RefreshCw size={14} />
            Refresh
          </button>
          <button 
            className={styles.dismissButton}
            onClick={onDismiss}
            title="Dismiss notification"
          >
            <X size={14} />
          </button>
        </div>
      </div>
    </div>
  );
};